import type { RoutePathOption, RoutePlan } from '@gpx-spa/geo-domain'
import { pathIdForSegment } from '@/utils/device-api-shipment-payload'

export type FlattenedRoutePlanPath = {
  segmentIndex: number
  pathIndex: number
  pathId: string
  path: RoutePathOption
  provider?: string
  fromStopIndex: number
  toStopIndex: number
}

export function flattenRoutePlanPaths(
  plan: RoutePlan | null | undefined,
): FlattenedRoutePlanPath[] {
  if (!plan?.segments?.length) return []
  const out: FlattenedRoutePlanPath[] = []
  for (let s = 0; s < plan.segments.length; s++) {
    const segment = plan.segments[s]
    if (!segment) continue
    const paths = segment.paths ?? []
    for (let i = 0; i < paths.length; i++) {
      const path = paths[i]!
      out.push({
        segmentIndex: s,
        pathIndex: i,
        pathId: pathIdForSegment(s, path, i),
        path,
        provider: path.meta?.provider,
        fromStopIndex: segment.fromStopIndex,
        toStopIndex: segment.toStopIndex,
      })
    }
  }
  return out
}

export function routePlanPathCount(plan: RoutePlan | null | undefined): number {
  return flattenRoutePlanPaths(plan).length
}
